import { Component, computed, inject, input } from '@angular/core';
import { provideIcons } from '@ng-icons/core';
import { lucideX } from '@ng-icons/lucide';
import { HlmButtonImports } from '@spartan-ng/helm/button';
import { HlmIconImports } from '@spartan-ng/helm/icon';
import { hlm } from '@spartan-ng/helm/utils';
import { cva, VariantProps } from 'class-variance-authority';
import type { ClassValue } from 'clsx';

import { SidepanelService } from './sidepanel.service';

export const listVariants = cva(
  'border-stroke-neutral-light absolute top-0 bottom-0 z-999 flex w-2xl flex-col overflow-y-hidden bg-white transition-transform duration-300 ease-in-out',
  {
    variants: {
      position: {
        right: 'right-0 border-l',
        left: 'left-0 border-r',
      },
      open: {
        true: 'translate-x-0',
        false: '',
      },
    },
    compoundVariants: [
      {
        position: 'left',
        open: false,
        className: '-translate-x-full',
      },
      {
        position: 'right',
        open: false,
        className: 'translate-x-full',
      },
    ],
    defaultVariants: {
      position: 'right',
      open: false,
    },
  },
);
type ListVariants = VariantProps<typeof listVariants>;

@Component({
  selector: 'app-sidepanel',
  imports: [HlmButtonImports, HlmIconImports],
  template: '<ng-content />',
  providers: [provideIcons({ lucideX })],
  host: {
    '[class]': '_computedClass()',
  },
})
export class SidepanelComponent {
  readonly #sidepanelService = inject(SidepanelService);

  public readonly position = input<ListVariants['position']>('right');
  public readonly userClass = input<ClassValue>('', { alias: 'class' });

  public readonly isOpen = this.#sidepanelService.isOpen;

  protected readonly _computedClass = computed(() =>
    hlm(listVariants({ position: this.position(), open: this.isOpen() }), this.userClass()),
  );
}
